/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoUserControllerResolveCityMutationRequest,
  TelegramGeoUserControllerResolveCityMutationResponse,
  TelegramGeoUserControllerResolveCity401,
} from '../types/TelegramGeoUserControllerResolveCity.ts';

function getTelegramGeoUserResolveCityUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/geo/resolve-city` as const };
  return res;
}

/**
 * {@link /api/user/telegram/geo/resolve-city}
 */
export async function telegramGeoUserResolveCity(
  data?: TelegramGeoUserControllerResolveCityMutationRequest,
  config: Partial<RequestConfig<TelegramGeoUserControllerResolveCityMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramGeoUserControllerResolveCityMutationResponse,
    ResponseErrorConfig<TelegramGeoUserControllerResolveCity401>,
    TelegramGeoUserControllerResolveCityMutationRequest
  >({ method: 'POST', url: getTelegramGeoUserResolveCityUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
